module.exports = __webpack_public_path__ + "img/wipple-version-0-13-1.155f7e44.png";